export const clampReservedLimit = (value: number): number => Math.max(1, value);
